"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _loggers = require("customer-data-tracking/loggers");

var _DateCategoryInput = _interopRequireDefault(require("crm_ui/components/input/DateCategoryInput"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnSpreads = _interopRequireDefault(require("UIComponents/column/UIColumnSpreads"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIColumnWrapper = _interopRequireDefault(require("UIComponents/column/UIColumnWrapper"));

var PureRenderMixin = _react.default.addons.PureRenderMixin;
var FollowUpArea = (0, _createReactClass.default)({
  mixins: [PureRenderMixin],
  propTypes: {
    includeFollowUpTask: _propTypes.default.bool.isRequired,
    handleFollowUpTaskToggle: _propTypes.default.func.isRequired,
    handleFollowUpCategoryChange: _propTypes.default.func,
    followUpDateCategories: _propTypes.default.array,
    selectedFollowUpCategory: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
    objectType: _ObjectTypesType.default.isRequired,
    integratedCalendarType: _propTypes.default.bool,
    isDisabled: _propTypes.default.bool,
    children: _propTypes.default.node
  },
  onCategorySelect: function onCategorySelect(category) {
    var objectType = this.props.objectType;

    if (category) {
      _loggers.CrmLogger.log('changeFollowUpTaskDate', {
        action: 'changed date',
        customDate: typeof category.value !== 'number'
      });

      _loggers.CrmLogger.logRecordInteraction(objectType, {
        action: 'Auto created follow up task - changed date',
        type: category && (typeof category.value === 'number' ? 'category' : 'custom date')
      });
    }

    this.props.handleFollowUpCategoryChange(category);
  },
  getFollowUpLabel: function getFollowUpLabel() {
    var _this$props = this.props,
        includeFollowUpTask = _this$props.includeFollowUpTask,
        selectedFollowUpCategory = _this$props.selectedFollowUpCategory;
    var message = 'interactionWithFollowUpTask.followUpEmptyState';

    if (includeFollowUpTask) {
      if (typeof selectedFollowUpCategory === 'number') {
        message = 'interactionWithFollowUpTask.followUpLabelTimestamp';
      } else {
        message = 'interactionWithFollowUpTask.followUpLabelCategory';
      }
    }

    return _react.default.createElement(_FormattedHTMLMessage.default, {
      className: "m-right-1",
      message: message
    });
  },
  renderSelect: function renderSelect() {
    if (!this.props.includeFollowUpTask) {
      return null;
    }

    return _react.default.createElement(_DateCategoryInput.default, {
      categories: this.props.followUpDateCategories,
      selectedCategory: this.props.selectedFollowUpCategory,
      onCategorySelect: this.onCategorySelect
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        integratedCalendarType = _this$props2.integratedCalendarType,
        isDisabled = _this$props2.isDisabled,
        includeFollowUpTask = _this$props2.includeFollowUpTask,
        handleFollowUpTaskToggle = _this$props2.handleFollowUpTaskToggle;
    var Component = integratedCalendarType ? _UIColumn.default : _UIColumnSpreads.default;
    return _react.default.createElement(Component, {
      className: "display-inline"
    }, _react.default.createElement(_UIColumnWrapper.default, {
      align: "center",
      className: "justify-start"
    }, children, _react.default.createElement(_UIColumn.default, null, _react.default.createElement(_UITooltip.default, {
      title: _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "interactionWithFollowUpTask.disabled"
      }),
      disabled: !isDisabled
    }, _react.default.createElement(_UICheckbox.default, {
      disabled: isDisabled,
      size: "small",
      alignment: "center",
      checked: includeFollowUpTask,
      onChange: handleFollowUpTaskToggle,
      className: "m-left-4",
      "data-selenium-test": "follow-up-task-checkbox"
    }, _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "start",
      direction: "row",
      wrap: "wrap"
    }, this.getFollowUpLabel(), this.renderSelect()))))));
  }
});
var _default = FollowUpArea;
exports.default = _default;
module.exports = exports.default;